import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import { MaterialIcon } from '../../components';
import { GLOBAL_ICONS } from '../../util/vars';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;

const UpdateViewButton = ({ ...other }: HTMLProps): JSX.Element => {

  const { translate } = useI18n();

  return (
    <div className={'leading-none'}>
      <div className={'italic text-sm'}> {translate('pages.TOPIC.RELOAD')}</div>
      <button className={'appearance-none flex items-center'} {...other}>
        <MaterialIcon icon={GLOBAL_ICONS.reload} color={'dark'} size={24} className={'mr-sm'} />
        <span className={'font-bold underline hover:no-underline'} >
          {translate('components.BUTTONS.UPDATE')}
        </span>
      </button>
    </div>
  );
};

UpdateViewButton.displayName = 'UpdateViewButton';

export default UpdateViewButton;
